import React, { useState } from 'react'

type ErrorProps = {
  name: string
  errors?: any
  index?: number | null
  group?: any
}

const Error = ({
  name = '',
  errors,
  index = null,
  group
} : ErrorProps) => {

  return (
    <>
      {index !== null ? (
        <>
          {errors?.[group]?.[index]?.[name]?.message && (
            <div className="ant-form-item-explain ant-form-item-explain-connected">
              <p style={{color: '#ff4d4f'}} className="ant-form-item-explain-error">{errors?.[group]?.[index]?.[name]?.message}</p>
            </div>
          )}
        </>
      ) : (
        <>
          {errors?.[name]?.message && (
            <div className="ant-form-item-explain ant-form-item-explain-connected">
              <p style={{color: '#ff4d4f'}} className="ant-form-item-explain-error">{errors?.[name]?.message}</p>
            </div>
          )}
        </>
      )}
      
    </>
  )
}

export default Error